import { Link } from 'react-router-dom';
import { Instagram, Mail, MapPin, Phone } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_aura-k-beauty/artifacts/knpm9ulf_2.png";

export default function Footer() {
  return (
    <footer className="bg-[var(--dark)] text-white/80" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="space-y-4">
            <img src={LOGO_URL} alt="Aura K Beauty" className="h-12 w-auto rounded" />
            <p className="text-sm text-white/60 leading-relaxed">
              Trayendo lo mejor del skincare coreano a Puerto Rico. Belleza autentica, resultados reales.
            </p>
            <div className="flex gap-3">
              <a href="https://instagram.com/aurakbeauty" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[var(--violet)] transition-colors" data-testid="instagram-link">
                <Instagram className="h-4 w-4" />
              </a>
              <a href="mailto:info@aurakbeauty.com" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[var(--violet)] transition-colors" data-testid="email-link">
                <Mail className="h-4 w-4" />
              </a>
              <a href="https://wa.me/17879491006" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#25D366] transition-colors" data-testid="whatsapp-footer-link">
                <Phone className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm tracking-wider uppercase">Tienda</h4>
            <div className="space-y-2.5">
              {[
                { label: 'Limpiadores', key: 'limpiadores' },
                { label: 'Toners', key: 'toners' },
                { label: 'Serums', key: 'serums' },
                { label: 'Protectores Solares', key: 'protectores_solares' },
                { label: 'Piel Grasa', key: 'piel_grasa' },
                { label: 'Piel Sensible', key: 'piel_sensible' },
                { label: 'Kits', key: 'kits' },
              ].map(cat => (
                <Link key={cat.key} to={`/tienda?category=${cat.key}`} className="block text-sm text-white/50 hover:text-[var(--sage)] transition-colors">
                  {cat.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Info */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm tracking-wider uppercase">Informacion</h4>
            <div className="space-y-2.5">
              <Link to="/nosotros" className="block text-sm text-white/50 hover:text-[var(--sage)] transition-colors">Sobre Nosotros</Link>
              <Link to="/educacion" className="block text-sm text-white/50 hover:text-[var(--sage)] transition-colors">Aura Skin Lab</Link>
              <Link to="/kits" className="block text-sm text-white/50 hover:text-[var(--sage)] transition-colors">Kits y Rutinas</Link>
              <Link to="/blog" className="block text-sm text-white/50 hover:text-[var(--sage)] transition-colors">Blog</Link>
              <Link to="/contacto" className="block text-sm text-white/50 hover:text-[var(--sage)] transition-colors">Contacto</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm tracking-wider uppercase">Contacto</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2.5">
                <MapPin className="h-4 w-4 mt-0.5 text-[var(--sage)]" />
                <span className="text-sm text-white/50">Puerto Rico</span>
              </div>
              <div className="flex items-start gap-2.5">
                <Mail className="h-4 w-4 mt-0.5 text-[var(--sage)]" />
                <span className="text-sm text-white/50">info@aurakbeauty.com</span>
              </div>
              <div className="flex items-start gap-2.5">
                <Phone className="h-4 w-4 mt-0.5 text-[var(--sage)]" />
                <a href="https://wa.me/17879491006" target="_blank" rel="noopener noreferrer" className="text-sm text-white/50 hover:text-[#25D366]">787-949-1006 (WhatsApp)</a>
              </div>
              <div className="flex items-start gap-2.5">
                <Instagram className="h-4 w-4 mt-0.5 text-[var(--sage)]" />
                <a href="https://instagram.com/aurakbeauty" target="_blank" rel="noopener noreferrer" className="text-sm text-white/50 hover:text-[var(--sage)]">@aurakbeauty</a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 text-center text-xs text-white/30">
          &copy; {new Date().getFullYear()} Aura K Beauty. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
}
